import { CardProtectionExclusion } from "src/containers/card-protection/domain/exclusion";
import { ReactComponent as BuildingWearIcon } from "src/assets/icons/hogar/icon_desgaste_edificacion.svg";

const exclusions = [
    {
        id: "clonacion-tarjetas",
        title: "Clonación de tarjetas",
        shortTitle: "Clonación de tarjetas",
        icon: <BuildingWearIcon />,
    },
    {
        id: "fraude-tarjeta",
        title: "Fraude (estafa) realizado con tus tarjetas de crédito",
        shortTitle: "Fraude (estafa) realizado con tus tarjetas de crédito",
        icon: <BuildingWearIcon />,
    },
    {
        id: "tarjetas-adicionales",
        title: "Tarjetas adicionales donde no figure tu nombre en el plástico",
        shortTitle:
            "Tarjetas adicionales donde no figure tu nombre en el plástico",
        icon: <BuildingWearIcon />,
    },
    {
        id: "uso-extranjero",
        title: "Uso indebido de tus tarjetas fuera del territorio nacional",
        shortTitle:
            "Uso indebido de tus tarjetas fuera del territorio nacional",
        icon: <BuildingWearIcon />,
    },
    {
        id: "otros",
        title: "Otras exclusiones",
        shortTitle: "Otras exclusiones",
        icon: <></>,
        content: (
            <>
                <div className="exclusion-content__section">
                    <div className="exclusion-content__text bullet">
                        Uso indebido después de la hora máxima estipulada en las
                        condiciones de la póliza
                    </div>
                    <div className="exclusion-content__text bullet">
                        Pérdidas que el asegurdo pueda cobrar y obtener
                        reembolso de otra entidad financiera
                    </div>
                    <div className="exclusion-content__text bullet">
                        Daños o responsabilidades sobre fallas en el
                        reconocimiento electrónico de fechas
                    </div>
                    <div className="exclusion-content__text bullet">
                        Robo de otro intrumento negociable (cheque de viajero,
                        dinero en posesión) en el momento del siniestro
                    </div>
                    <div className="exclusion-content__text bullet">
                        Tarjetas (crédito y débito) de alguna entidad no
                        regulada por la SBS del Perú
                    </div>
                    <div className="exclusion-content__text bullet">
                        Robo, asalto o secuestro a un familiar tuyo que tenga
                        una relación dentro del cuarto grado de consanguinidad o
                        segundo de afinidad o único civil o empleado del
                        asegurado así como pérdidas de empleados deshonestos
                    </div>
                    <div className="exclusion-content__text bullet">
                        Actos delictivos por parte del asegurado
                    </div>
                    <div className="exclusion-content__text bullet">
                        Pérdida de intereses o financiera del cobro generado
                        generado por culquier persona o entidad que le haya
                        emitido tarjetas
                    </div>
                    <div className="exclusion-content__text bullet">
                        Entrega de comprobantes de venta con demora al plazo
                        asignado
                    </div>
                    <div className="exclusion-content__text bullet">
                        Cuando el siniestro se dio como consecuencia de:
                        desastre natural, guerras y huelgas
                    </div>
                </div>
                <div className="exclusion-content__section">
                    <div className="exclusion-content__text">
                        Para muerte accidental:
                    </div>
                    <div className="exclusion-content__text bullet">
                        Suicidio a pesar del estado mental
                    </div>
                    <div className="exclusion-content__text bullet">
                        Acto intencional por asegurado y beneficiarios
                    </div>
                </div>
                <div className="exclusion-content__section exclusion-content__text info">
                    Las exclusiones se detallan en el certificado del seguro y
                    en las condiciones particulares, así como la cláusula
                    adicional que corresponda
                </div>
            </>
        ),
    },
] as CardProtectionExclusion[];

export default exclusions;
